import React, {useState, useContext} from 'react'
import {Radio, RadioGroup, FormControl, FormControlLabel, Button} from '@material-ui/core/'
import {userUpdate} from '../../graphql/barcode/mutations/userSettingMutation'
import {Mutation} from 'react-apollo'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeSettings.styles'
import {ToastMessageContext} from '../../context/ToastMessage'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'

function BarcodeSettings(props) {
  const toast = useContext(ToastMessageContext)
  const classes = useStyles()
  const {t} = useTranslation()
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const [value, setValue] = useState((userSettings || {}).setting || '')

  function handleChange(event) {
    setValue(event.target.value)
  }

  function handleSave(event, update) {
    if (event.currentTarget.value === 'cancel') {
      props.closePopup(null)
    } else {
      const clickValue = event.currentTarget.value === 'save' ? value : 'library'
      update({
        variables: {id: userSettings.id, setting: clickValue},
      })
      toast.popMessage('Default Page has been updated.', 'success', event.currentTarget)
    }
  }

  return (
    <div className={classes.root}>
      {/* <SessionCookies> */}
      <FormControl component="fieldset" className={classes.formControl}>
        <h5 className="mb-3 mx-3">{t('barcode.main-header.settings-option.default')}</h5>

        <RadioGroup className={classes.group} value={value} onChange={handleChange}>
          <FormControlLabel
            className="mb-3"
            value="library"
            control={<Radio color="primary" />}
            label={t('barcode.main-header.settings-option.library-text')}
          />
          <FormControlLabel
            value="wizard"
            className="mb-3"
            control={<Radio color="primary" />}
            label={t('barcode.main-header.settings-option.wizard-text')}
          />
          <FormControlLabel
            value="other"
            control={<Radio color="primary" />}
            label={t('barcode.main-header.settings-option.other-text')}
          />
        </RadioGroup>
        <div>
          <Mutation mutation={userUpdate}>
            {(userUpdate, {data}) => (
              <div>
                <Button
                  variant="contained"
                  className={classes.button}
                  value="cancel"
                  onClick={e => handleSave(e, userUpdate)}
                >
                  {t('barcode.main-header.settings-option.cancel')}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  value="save"
                  onClick={e => handleSave(e, userUpdate)}
                >
                  {t('barcode.main-header.settings-option.save-changes')}
                </Button>
              </div>
            )}
          </Mutation>
        </div>
      </FormControl>
    </div>
  )
}

export default BarcodeSettings
